'use strict';
var $ = require('jquery');

module.exports = {
    getScrollYPosition: function () {
        return window.scrollY || window.pageYOffset;
    },

    focus: function (selector) {
        $(selector).focus();
    },

    scrollTopAnimate: function (selector, margin) {
        $('html, body').animate({
            scrollTop: $(selector).offset().top - margin
        }, 1000);
    },

    moveToNextSection: function (className) {
        var selector = '[class=' + className + ']';
        this.scrollTopAnimate(selector, 0);
        this.focus(selector);
    },

    moveToNextFormSection: function (id, inputName) {
        this.scrollTopAnimate('#' + id, 65);
        this.focus('input[name=' + inputName + ']:first');
    },

    moveToNextError: function (className, errorBarDisplayed) {
        var offset = -65;
        if (errorBarDisplayed) {
            offset = -130
        }

        //TODO : this is a workaround while we still have both selector on id  and class
        //will only keey the selector on id when doing error handling
        //Also, probably better to get rid of jquery selector, and using the react way
        var selector = $('[class=' + className + ']'); //document.getElementsByClassName(className);
        if (!selector || selector.length <= 0) {
            selector = $('#' + className);
        }

        if (selector && typeof selector['offset'] === 'function' && selector.offset()) {
            $('html, body')
                .animate({
                        scrollTop: selector.offset().top + (offset)
                    },
                    1000);
            this.focus(selector);
        }
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/Screen.js